<div class="mobile-salesorder-viewport po-p-2">
  
  <div class="salesorder-card reveal" *ngFor="let item of myData">
    
    <div class="card-section header-bg">
      <div class="po-row">
        <div class="po-sm-12" *ngIf="item.personName">
          <span class="label-muted">CLIENTE</span>
          <h3 class="value-highlight">{{ item.personName }}</h3>
        </div>
        <div class="po-sm-6">
          <span class="label-muted">PEDIDO</span>
          <span class="value-small">#{{ item.orderCode }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">SITUAÇÃO</span>
          <span class="status-badge-mini" [ngClass]="getStatusClass(item.statusOrder)">
            {{ item.statusOrder }}
          </span>
        </div>
      </div>
    </div>

    <div class="card-section border-y">
      <div class="po-row">
        <div class="po-sm-6" *ngIf="item.billingForecastDate">
          <span class="label-muted">PREV. FATURAMENTO</span>
          <span class="value-data">{{ item.billingForecastDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="po-sm-6 text-right" *ngIf="item.stageOrder">
          <span class="label-muted">ESTÁGIO</span>
          <span class="value-data">{{ item.stageOrder }}</span>
        </div>
      </div>
    </div>

    <div class="card-section bg-neutral-soft">
      <div class="po-row po-mb-1">
        <div class="po-sm-6">
          <span class="label-muted">VALOR BRUTO</span>
          <span class="value-money">{{ item.grossValue | currency:'BRL' }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">DESCONTO</span>
          <span class="value-money text-success">- {{ item.discountValue | currency:'BRL' }}</span>
        </div>
      </div>
      <div class="po-row po-mb-2">
        <div class="po-sm-6">
          <span class="label-muted">FRETE</span>
          <span class="value-money">{{ item.freightValue | currency:'BRL' }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">QTD TOTAL</span>
          <span class="value-money">{{ item.quantity }} un</span>
        </div>
      </div>
      <div class="total-row-highlight">
        <span class="label-muted">TOTAL DO PEDIDO</span>
        <span class="value-total">{{ item.totalValue | currency:'BRL' }}</span>
      </div>
    </div>

    <div class="card-section accordion-section" *ngIf="item.quantity > 0" (click)="seeDescriptionItens(item)">
      <div class="titulo-itens-lux">
        <span>Itens do pedido</span>
        <!-- <span>Itens do pedido ({{ item.salesOrderItens?.length }})</span> -->
        <div class="icon-container">
          <i class="ph ph-caret-down" [class.rotated]="item.expanded"></i>
        </div>

      </div>

      <div class="items-container" *ngIf="item.expanded">
        <div *ngFor="let i of item.salesOrderItens" class="item-inner-card">
          <div class="item-header">
            <span class="item-name">{{ i.productName }}</span>
            <span class="item-code">{{ i.productCode }}</span>
          </div>
          <div class="item-grid">
            <div class="grid-cell item-1"><label>REF:</label> {{ i.referenceCode }}</div>
            <div class="grid-cell item-2"><label>QTD:</label> {{ i.quantity }}</div>
            <div class="grid-cell item-3"><label>LIQUID:</label> {{ i.settledQuantity }}</div>
          </div>
          <div class="item-footer">
            <span>{{ i.price | currency:'BRL' }} /un</span>
            <span class="item-discount">- {{ i.discountValue | currency:'BRL' }}</span>
            <span class="item-total-val">{{ i.totalValue | currency:'BRL' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-section footer-actions">
      <button class="btn-action-lux-full" (click)="downloadPDFCard(item)">
        <i class="ph ph-file-pdf"></i>
        <span>BAIXAR PDF DO PEDIDO</span>
      </button>
    </div>

  </div>
</div>